import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import Schemas from '../models';
import { actions } from '../../constants';
import { fetchListener } from './auth';
import { getWorksPagination } from '../selectors/works';
import { getAllCategories } from '../selectors/categories';

function* getWorks(data) {
  const onSuccess = function*(response) {
    yield put({ type: actions.WORKS.LOAD_SUCCESS, payload: response });
  };

  const onError = function*(error) {
    yield put({ type: actions.WORKS.LOAD_FAIL, payload: error });
  };

  let page = 1;
  if (!data.payload.refresh) {
    let pagination = yield select(getWorksPagination);

    if (pagination.current_page < pagination.total_pages) {
      page += pagination.current_page;
    }
  }

  let categoryFilter = '';
  if (data.payload.slug) {
    let categories = yield select(getAllCategories);
    let category = categories.find(category => {
      return category.slug === data.payload.slug;
    });

    if (category) categoryFilter = '&category_id=' + category.id;
  }

  let orderField = 'date';
  if (data.payload.options && data.payload.options.sort) {
    orderField = data.payload.options.sort;
  }

  yield call(fetchListener, {
    url:
      'api/works?order=' +
      orderField +
      ',desc' +
      categoryFilter +
      '&page=' +
      page,
    method: 'GET',
    schema: Schemas.WORK_ARRAY,
    onSuccess: onSuccess,
    onError: onError,
    noAuth: true
  });
}

function* getWork(data) {
  const onSuccess = function*(response) {
    yield put({ type: actions.WORKS.LOAD_SINGLE_SUCCESS, payload: response });
  };

  const onError = function*(error) {
    yield put({ type: actions.WORKS.LOAD_SINGLE_FAIL, payload: error });
  };

  yield call(fetchListener, {
    url: 'api/works/' + data.payload.id + '?include=work_photos',
    method: 'GET',
    schema: Schemas.WORK,
    onSuccess: onSuccess,
    onError: onError,
    noAuth: true
  });
}

export default function* works() {
  yield all([
    yield takeLatest(actions.WORKS.LOAD, getWorks),
    yield takeLatest(actions.WORKS.LOAD_SINGLE, getWork)
  ]);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/works.js